export const E308_COMMIT = "b325f8166d0c1406eedce84934cc87495f4b1492";
export const CONTENT_VERSION = "kilnfront-ruleset-2";
export const CONTENT_DIGEST =
  "sha256:077c106b95c5d8c177deb9a7abdcdc739fcc44b51e55775f3798cf4f29150490";

export interface BuildIdentity {
  readonly product: "kilnfront";
  readonly sourceSha: string;
  readonly e308Commit: string;
  readonly contentVersion: string;
  readonly contentDigest: string;
  readonly artifactSha256: string;
  readonly onlinePlay: "ready";
}

export function buildIdentity(sourceSha: string, artifactSha256: string): BuildIdentity {
  return Object.freeze({
    product: "kilnfront",
    sourceSha,
    e308Commit: E308_COMMIT,
    contentVersion: CONTENT_VERSION,
    contentDigest: CONTENT_DIGEST,
    artifactSha256,
    onlinePlay: "ready",
  });
}
